/* eslint-disable */
// @ts-nocheck

import { ChevronRight } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface PathInterface {
  name: string
  action?: Function
}

interface InventoryBreadcrumbProp {
  paths: PathInterface[]
  icon: React.ReactNode
  className?: string
}

export default function InventoryBreadcrumb({ paths, icon, className }: InventoryBreadcrumbProp) {
  return (
    <nav
      aria-label="Breadcrumb"
      className={cn('mb-4 flex w-full items-center font-[Geist]', className)}
    >
      <ol className="flex items-center space-x-2" role="list">
        <li className="flex items-center space-x-2">
          <div className="text-gray-400">
            {icon}
            <span className="sr-only">Home</span>
          </div>
          {paths[0] && (
            <span
              className={cn(
                'text-sm font-medium text-gray-600 hover:cursor-default',
                paths[0].action && 'hover:cursor-pointer hover:text-gray-800 hover:underline'
              )}
              onClick={() => (paths[0].action ? paths[0].action() : null)}
            >
              {paths[0].name}
            </span>
          )}
        </li>
        {paths.slice(1).map((current, index) => (
          <li className="flex items-center" key={current.name}>
            <ChevronRight className="h-4 w-4 text-gray-400 mx-1" />
            <span
              className={cn(
                'text-sm font-medium text-gray-600 hover:cursor-default',
                current.action && 'hover:cursor-pointer hover:text-gray-800 hover:underline',
                index === paths.slice(1).length - 1 && 'text-gray-900' // Último elemento más oscuro
              )}
              onClick={() => (current.action ? current.action() : null)}
            >
              {current.name}
            </span>
          </li>
        ))}
      </ol>
    </nav>
  )
}
